module.exports = __webpack_public_path__ + "media/mypage/images/fa/6-4c02de633a469e7311b2b66b07fda287.jpg";